import { useDispatch } from "react-redux";
import {
  setFlag,
  setIsPopup,
  setLoading,
  setResponseDescription,
  setResponseInfo,
  setResponseTitle,
} from "../features/responseSlice";
import { toast } from "react-toastify";
import { setValidationInfo } from "../features/authorizationSlice";
import useLogout from "../api/logoutApi";
import { settingData } from "../features/legalEnrollmentSlice";

const useResponse = () => {
  const dispatch = useDispatch();
  const { logout } = useLogout();
  const successResponse = (res) => {
    dispatch(setValidationInfo(null));
    dispatch(setLoading("idle"));

    if (Number(res?.flagCode) === 84) {
      dispatch(setFlag(84));
      dispatch(
        setResponseInfo({
          amount: res?.amount,
          currencyFrom: res?.currencyFrom,
          currencyTo: res?.currencyTo,
        })
      );
      dispatch(setIsPopup(true));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
      return;
    }

    if (Number(res?.flagCode) === 90) {
      dispatch(setFlag(90));
      dispatch(
        setResponseInfo({
          amount: res?.amount,
          currencyFrom: res?.currencyFrom,
          currencyTo: res?.currencyTo,
        })
      );
      dispatch(setIsPopup(true));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
      return;
    }
    if (Number(res?.flagCode) === 11) {
      dispatch(setFlag(11));
      dispatch(
        setResponseInfo({
          amount: res?.amount,
          currencyFrom: res?.currencyFrom,
          currencyTo: res?.currencyTo,
        })
      );
      dispatch(setIsPopup(true));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
      return;
    }

    if (res.isPopup) {
      dispatch(setIsPopup(true));
      dispatch(setFlag(res?.flagCode || 0));
      dispatch(setResponseTitle(res.Title));
      dispatch(setResponseDescription(res.Message));
      if (res.InstallEsim) {
        dispatch(setResponseInfo({ InstallEsim: res.InstallEsim }));
      }
    } else {
      dispatch(setFlag(0));
      //res.Title?
      toast.success(res.Message || res.Title);
    }

    // if (res.Payload.isPopup) {
    //   dispatch(setIsPopup(true));
    //   dispatch(setFlag(res?.Payload.flagCode || 0));
    //   dispatch(setResponseTitle(res.Payload.Title));
    //   dispatch(setResponseDescription(res.Payload.Message));
    // } else {
    //   dispatch(setFlag(0));
    //   //res.Title?
    //   toast.success(res.Payload.Message || res.Payload.Title);
    // }
  };

  const errorResponse = (error) => {
    dispatch(setValidationInfo(null));
    if (error?.response?.status === 401) {
      logout();
      return;
    }

    if (error?.response?.data?.isPopup) {
      if (error.response.data.PopupTitle === "LoaderError") {
        return;
      }
      if (error?.response?.status === 435 || error?.response?.status === 436) {
        dispatch(setFlag(error.response.status));
      } else {
        dispatch(setFlag(10));
      }
      dispatch(setLoading("idle"));
      dispatch(setIsPopup(true));
      dispatch(setResponseTitle(error.response.data.PopupTitle));
      dispatch(setResponseDescription(error.response.data.PopupDescription));
    } else {
      dispatch(setLoading("pending"));
    }
  };

  return {
    successResponse,
    errorResponse,
  };
};
export default useResponse;

